import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.formDialog,
      callback: function ($$v) {
        _vm.formDialog = $$v;
      },
      expression: "formDialog"
    }
  }, [_c('niota-classic-devicetypes-create-edit-dialog', {
    attrs: {
      "isEditForm": "",
      "isOpen": _vm.formDialog,
      "editedItem": _vm.editedItem
    },
    on: {
      "close": _vm.closeForm,
      "update": _vm.updateItem
    }
  })], 1), _c('niota-classic-devicetypes-syncronize-health-states-dialog', {
    attrs: {
      "tenantId": _vm.tenantId,
      "dialogSyncHealthStateOpen": _vm.dialogSyncHealthStateOpen,
      "linkedVirtualDevicesIds": _vm.linkedVirtualDevicesIds
    },
    on: {
      "close": function ($event) {
        return _vm.closeSyncHealthStateDialog();
      }
    }
  }), _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.deviceHealth.unsavedTitle'),
      "open": _vm.unsavedPrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.switchParserPromptConfirm'),
        color: 'danger',
        emit: 'discard-changes'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.unsavedPrompt = false;
      },
      "discard-changes": function ($event) {
        return _vm.unsavePromptNextPersist();
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.deviceHealth.unsavedText')) + "\n  ")]), _c('core-header', {
    attrs: {
      "subtitle": _vm.$i18n_tc('NiotaClassic.DeviceTypes.linkedDevices', (_vm.deviceTypeData || {}).deviceCount || 0, {
        n: (_vm.deviceTypeData || {}).deviceCount || 0
      }),
      "headerBG": "./img/transparent.png",
      "buttons": _vm.cardButtons,
      "isLoading": _vm.detailsLoaded
    },
    on: {
      "cancel": function ($event) {
        return _vm.$router.push('/niota-classic/device-types');
      },
      "edit": _vm.handleEditDeviceType,
      "copy": _vm.handleCopyDeviceType
    },
    scopedSlots: _vm._u([{
      key: "headline",
      fn: function () {
        return [(_vm.deviceTypeData || {}).image ? _c('img', {
          staticClass: "device-image",
          attrs: {
            "src": _vm.getDeviceTypeImageUrl((_vm.deviceTypeData || {}).image),
            "width": "42",
            "height": "42"
          }
        }) : _vm._e(), ((_vm.deviceTypeData || {}).properties || {}).certified ? _c(VIcon, {
          attrs: {
            "color": "green",
            "medium": ""
          }
        }, [_vm._v("\n        fal fa-badge-check\n      ")]) : _vm._e(), _vm._v("\n      " + _vm._s((_vm.deviceTypeData || {}).title || 'Devicetype') + "\n    ")];
      },
      proxy: true
    }])
  }), _c(VRow, {
    staticClass: "n20-mainrow pb-4",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', {
    staticClass: "mb-8"
  }, [_c(VTabs, {
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabsSlider, {
    attrs: {
      "color": _vm.color
    }
  }), _c(VTab, {
    attrs: {
      "href": "#details"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3"
  }, [_vm._v("fal fa-book-open")]), _vm._v("\n            " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.details')) + "\n          ")], 1), _c(VTab, {
    attrs: {
      "href": "#devices"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3"
  }, [_vm._v("fal fa-sensor-on")]), _vm._v("\n            " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.devices')) + "\n            " + _vm._s(_vm.linkedDeviceTypes !== null ? `(${_vm.linkedDeviceTypes})` : '') + "\n          ")], 1), _vm.isDeviceDriverFallbakActive ? _c(VTab, {
    attrs: {
      "href": "#virtualdevices"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3"
  }, [_vm._v("fal fa-sensor-on")]), _vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.drawer.virtualDevices')) + "\n            " + _vm._s(_vm.linkedVirtualDevices !== null ? `(${_vm.linkedVirtualDevices})` : '') + "\n          ")], 1) : _vm._e(), _c(VTab, {
    attrs: {
      "href": "#packet-parser"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3"
  }, [_vm._v("fal fa-code-branch")]), _vm._v("\n            " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.packetParser')) + "\n          ")], 1), _vm.isDeviceDriverFallbakActive ? _c(VTab, {
    attrs: {
      "href": "#health-state"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3"
  }, [_vm._v("fal fa-heartbeat")]), _vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.headline')) + "\n          ")], 1) : _vm._e(), _c(VTab, {
    attrs: {
      "href": "#downlinks"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3"
  }, [_vm._v("fal fa-level-down-alt")]), _vm._v("\n            " + _vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.downlinks')) + "\n          ")], 1), _c(VTabsItems, {
    staticClass: "mt-4",
    attrs: {
      "touchless": ""
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabItem, {
    key: "details",
    attrs: {
      "value": "details"
    }
  }, [_c('niota-classic-devicetypes-details', {
    attrs: {
      "deviceTypeId": _vm.deviceTypeId,
      "deviceTypeData": _vm.deviceTypeData
    }
  })], 1), _c(VTabItem, {
    key: "devices",
    attrs: {
      "value": "devices"
    }
  }, [_c('niota-classic-devicetypes-linked-devices-list', {
    attrs: {
      "deviceTypeId": _vm.deviceTypeId
    }
  })], 1), _c(VTabItem, {
    key: "virtualdevices",
    attrs: {
      "value": "virtualdevices"
    }
  }, [_c('core-virtual-device-list', {
    ref: "vdevicelist",
    attrs: {
      "accounts": [],
      "searchTypes": _vm.virtualDeviceSearchTypes,
      "predefinedSearch": [{
        param: 'deviceType',
        search: _vm.deviceTypeId
      }],
      "restoreFilter": false,
      "favouriteFilterEnabled": false,
      "containerClass": "pa-0"
    }
  })], 1), _c(VTabItem, {
    key: "packet-parser",
    attrs: {
      "value": "packet-parser",
      "eager": ""
    }
  }, [_c('niota-classic-devicetypes-packet-parser-wrapper', {
    ref: "parserWrapper",
    attrs: {
      "deviceTypeId": _vm.deviceTypeId,
      "deviceTypeData": _vm.deviceTypeData,
      "readonly": !_vm.isIotHubManager,
      "call-from-device-type": ""
    }
  })], 1), _c(VTabItem, {
    key: "health-state",
    attrs: {
      "value": "health-state"
    }
  }, [_c('core-n20Card', {
    staticClass: "dt-card-text-01 px-0 mx-0",
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.headline'),
      "buttons": _vm.healthCareButtons
    },
    on: {
      "applied": _vm.showDialogSyncHealthState,
      "submitted": _vm.persistHealthStateConfig
    }
  }, [_c(VForm, {
    ref: "healthConfigForm",
    model: {
      value: _vm.healthStateFormValid,
      callback: function ($$v) {
        _vm.healthStateFormValid = $$v;
      },
      expression: "healthStateFormValid"
    }
  }, [_c('div', {
    staticClass: "pt-4"
  }, [_c('core-dtwin-state-virtual-device-aggregate-health', {
    ref: "healthStateEdit",
    attrs: {
      "deviceTypeObject": _vm.deviceTypeData,
      "usage": "device-type"
    },
    on: {
      "bridge-binding-changed": e => {
        _vm.healthStateConfig = e.config;
      }
    },
    model: {
      value: _vm.healthStateConfig,
      callback: function ($$v) {
        _vm.healthStateConfig = $$v;
      },
      expression: "healthStateConfig"
    }
  })], 1)])], 1)], 1), _c(VTabItem, {
    key: "downlinks",
    attrs: {
      "value": "downlinks"
    }
  }, [_c('niota-classic-devicetypes-downlinks', {
    attrs: {
      "deviceTypeId": _vm.deviceTypeId,
      "deviceTypeData": _vm.deviceTypeData
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };